import React from 'react';
import { useAppointmentState } from 'src/components/provider/AppointmentProvider';
import styles from './TermsOfUse.module.scss';

const SevenHillsTermsOfUse = () => {
  const { brandName } = useAppointmentState();
  return (
    <div>
      <p>{`Insert ${brandName} here.`}</p>
      <p>
        <strong>{"Don't you see, Bloom? darling Bloom? glorious Bloom? it's so simple!"}</strong>
      </p>
      <ol>
        <li>Find the worst play ever written</li>
        <li>We hire the worst director in town</li>
        <li>
          I raise two million dollars. Two? Yes, one for me one for you. Theres a lot of little old ladies out there
        </li>
        <li>We hire the worst actors in New York and open on Broadway, and before you can say: </li>
        <li>We C-L-O-S-E on broadway, take our two million and go to Rio </li>
      </ol>
      <em className={styles.emphasis}>- The Producers</em>
    </div>
  );
};

export default SevenHillsTermsOfUse;
